module.exports = __webpack_public_path__ + "static/media/image.b9f4f79f.svg";